import React, { Fragment, useCallback } from "react";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";

import { isWebbiewShareable, webviewSharePlaylist } from "helpers";

import { deleteEmbededPlaylist, deletePlaylist, embedPlaylist } from "actions/playlist.action";

import { STBBS_DOMAIN } from "constant/config";

import MoreButton from "components/MoreButton";
import PlaylistShare from "components/share/PlaylistShare";
import { ButtonLink } from "components/ButtonLink";

const PlayListMoreButton = ({ playlist, authority = {}, top }) => {
	const dispatch = useDispatch();

	// 재생목록 공유 하기
	const handleShare = useCallback(
		(changeContent, close) => (e) => {
			e.stopPropagation();
			e.nativeEvent.stopImmediatePropagation();
			if (isWebbiewShareable()) {
				webviewSharePlaylist(playlist);
				close();
			} else {
				changeContent(<PlaylistShare playlist={playlist} close={close} top={top} right={0} />);
			}
		},
		[playlist, top],
	);

	// 재생목록 퍼가기
	const handleEmbedPlaylist = async () => {
		await embedPlaylist(playlist.idx);
	};

	// 퍼간 재생목록 삭제
	const handleDeleteEmbededPlaylist = async () => {
		await dispatch(deleteEmbededPlaylist(playlist.idx));
	};

	// 생성한 재생목록 삭제
	const handleDeletePlaylist = async () => {
		await dispatch(deletePlaylist(playlist.idx));
	};

	return (
		<MoreButton
			trigger={
				<button type="button" className="btn-detail">
					<span>상세정보</span>
				</button>
			}
			right={0}
			top={top}
		>
			{({ changeContent, close }) => (
				<Fragment>
					{/* 재생목록 퍼가기 */}
					{authority.is_playlist_embeddable && (
						<button type="button" onClick={handleEmbedPlaylist}>
							<span>
								<Trans>재생목록 퍼가기</Trans>
							</span>
						</button>
					)}

					{/*  재생목록 공유하기 */}
					{authority.is_playlist_shareable && (
						<button type="button" onClick={handleShare(changeContent, close)}>
							<span data-id="share">
								<Trans>공유하기</Trans>
							</span>
						</button>
					)}

					{/* 재생목록 수정하기 */}
					{authority.is_playlist_updatable && (
						<ButtonLink to={`${STBBS_DOMAIN}/vodplaylist/index.php?nPlaylistIdx=${playlist.idx}`} target="_blank">
							<span>
								<Trans>수정하기</Trans>
							</span>
						</ButtonLink>
					)}

					{/* 퍼온 재생목록 삭제하기 */}
					{authority.is_playlist_embed_deletable && (
						<button type="button" onClick={handleDeleteEmbededPlaylist}>
							<span>
								<Trans>삭제하기</Trans>
							</span>
						</button>
					)}

					{/* 생성한 재생목록 삭제하기 */}
					{authority.is_playlist_deletable && (
						<button type="button" onClick={handleDeletePlaylist}>
							<span>
								<Trans>삭제하기</Trans>
							</span>
						</button>
					)}
				</Fragment>
			)}
		</MoreButton>
	);
};

export default PlayListMoreButton;
